import React from "react"
import PropTypes from "prop-types"
import { useNavigate, useLocation } from "react-router-dom"
import { Card, CardBody, Button } from "reactstrap"
import { Lock } from "lucide-react"
import { logoutGuestAndNavigateToLogin } from "../../utils/loginRedirect"

const GuestRestrictedPlaceholder = ({ 
  height = "300px", 
  message = "You're browsing as a Guest",
  subMessage = "Sign in to access full analytics and tracking features.",
  className = "" 
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  // "Continue as guest" sessions already carry a real `authUser`, which
  // makes `GuestMiddleware` immediately bounce `/login` back to `/dashboard`
  // - a plain `<Link to="/login">` here looked like clicking did nothing.
  // Clear the guest session first so the login page actually renders.
  const handleSignIn = () => {
    logoutGuestAndNavigateToLogin(location.pathname + location.search, navigate)
  }

  return (
    <Card 
      className={`guest-restricted-placeholder border-0 shadow-none ${className}`}
      style={{ 
        height: height, 
        backgroundColor: "#171821", 
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px dashed rgba(255, 255, 255, 0.1)"
      }}
    >
      <CardBody className="text-center d-flex flex-column align-items-center justify-content-center p-4">
        <div 
          className="mb-4 d-flex align-items-center justify-content-center"
          style={{
            width: "64px",
            height: "64px",
            borderRadius: "50%",
            background: "rgba(246, 37, 90, 0.1)",
            color: "#F6255A"
          }}
        >
          <Lock size={32} />
        </div>
        
        <h4 
          className="mb-2"
          style={{ 
            fontFamily: "Rubik, sans-serif", 
            fontWeight: 600, 
            color: "#fff",
            fontSize: "18px"
          }}
        >
          {message}
        </h4>
        
        <p 
          className="mb-4 mx-auto"
          style={{ 
            color: "rgba(255, 255, 255, 0.6)", 
            fontSize: "14px",
            maxWidth: "280px",
            lineHeight: "1.5"
          }}
        >
          {subMessage}
        </p>
        
        <Button
          color="primary"
          className="px-4 py-2"
          onClick={handleSignIn}
          style={{
            backgroundColor: "#F6255A",
            border: "none",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "14px",
            transition: "all 0.2s ease"
          }}
          onMouseOver={(e) => e.target.style.transform = "translateY(-2px)"}
          onMouseOut={(e) => e.target.style.transform = "translateY(0)"}
        >
          Sign In Now
        </Button>
      </CardBody>
    </Card>
  )
}

GuestRestrictedPlaceholder.propTypes = {
  height: PropTypes.string,
  message: PropTypes.string,
  subMessage: PropTypes.string,
  className: PropTypes.string
}

export default GuestRestrictedPlaceholder
